module.exports = __webpack_public_path__ + "static/Face-Adam.7a5b9c94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Face-Adam.jpg
// module id = 485
// module chunks = 144251824217401